import { render, staticRenderFns } from "./LoginByGoogle.vue?vue&type=template&id=5dc56a51&scoped=true"
import script from "./LoginByGoogle.vue?vue&type=script&lang=js"
export * from "./LoginByGoogle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc56a51",
  null
  
)

export default component.exports